// ======================================================================
// File: src/modules/ipe/engineering/mom/MOMCard.js
// Purpose:
//   MOM card per Enquiry Item
//   - Load MOM
//   - Generate MOM if not exists
//   - Display MOM operations
// ======================================================================

import React, { useEffect, useState } from "react";
import ipeEnquiryService from "../../services/ipeEnquiryService";
import MOMOperationsTable from "./MOMOperationsTable";

export default function MOMCard({ item }) {

  const [mom, setMom] = useState(null);
  const [operations, setOperations] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(true);

  // ------------------------------------------------------------
  // Load MOM
  // ------------------------------------------------------------
  async function loadMOM() {

    setLoading(true);

    try {

      const res = await ipeEnquiryService.getMOM(item.id);

      setMom(res || null);
      setOperations(res?.operations || res?.lines || []);

    } catch (e) {

      console.error("Failed to load MOM", e);

      setMom(null);
      setOperations([]);

    } finally {

      setLoading(false);

    }

  }

 useEffect(() => {

  loadMOM();

  }, [item.id]);

  // ------------------------------------------------------------
  // Generate MOM
  // ------------------------------------------------------------
  async function generateMOM() {

    try {

      await ipeEnquiryService.generateMOM({
        enquiry_item_id: item.id,
        equipment_id: item.equipment_id
      });

      await loadMOM();

    } catch (e) {

      console.error("Failed to generate MOM", e);
      alert("Failed to generate MOM");

    }

  }


  return (

    <div className="card mb-3">

      {/* ================= HEADER ================= */}

      <div
        className="card-header"
        style={{ cursor: "pointer" }}
        onClick={() => setExpanded(e => !e)}
      >

        <strong>
          {expanded ? "▼" : "▶"} Item #{item.item_seq_no} |
          Product Variant #{item.product_variant_id}
        </strong>

        <div className="text-muted small">
          Quantity: {item.quantity}
        </div>

        <div className="text-muted small">
          Equipment: {item.equipment_name || item.equipment_id}
        </div>

        {mom && (

          <div className="mt-1">

            <span className="badge bg-secondary me-1">
              MOM {mom.id}
            </span>

            <span className="badge bg-info me-1">
              Version {mom.version_no}
            </span>

            <span className="badge bg-dark">
              {mom.status}
            </span>

          </div>

        )}

      </div>


      {/* ================= BODY ================= */}

      {expanded && (

        <div className="card-body">

          {loading && (
            <div>Loading MOM…</div>
          )}

          {!loading && !mom && (

            <div className="alert alert-warning">

              MOM not generated yet.

              <div className="mt-2">

                <button
                  className="btn btn-primary btn-sm"
                  onClick={generateMOM}
                >
                  Generate MOM
                </button>

              </div>

            </div>

          )}

          {!loading && mom && (

            <MOMOperationsTable
              operations={operations}
              reload={loadMOM}
              momId={mom.id}   // ✅ ADD THIS
            />

          )}

        </div>

      )}

    </div>

  );

}